import { render, staticRenderFns } from "./rjquickBasicInformation.vue?vue&type=template&id=2bc6299c&scoped=true"
import script from "./rjquickBasicInformation.vue?vue&type=script&lang=js"
export * from "./rjquickBasicInformation.vue?vue&type=script&lang=js"
import style0 from "./rjquickBasicInformation.vue?vue&type=style&index=0&id=2bc6299c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc6299c",
  null
  
)

export default component.exports